module.exports = __webpack_public_path__ + "static/media/correctivo_verde.b460f07d.svg";